import { RadioGroup, FormLabel } from '@material-ui/core';
import { Controller } from 'react-hook-form';
import React from 'react';
import { ErrorMessage } from '@hookform/error-message';
import _ from 'lodash';

const RadioRhf = ({ question, name, control, formControlLabelRhf, defaultValue = '', errors, row = true }) => {
    return (
        <div id={name}>
            <FormLabel component="legend">{question}</FormLabel>
            <Controller
                rules={{ required: true }}
                control={control}
                name={name}
                render={({ field }) => (
                    <RadioGroup {...field} row={row}>
                        <>{formControlLabelRhf}</>
                    </RadioGroup>
                )}
                defaultValue={defaultValue}
            />
            <div style={{ marginLeft: 8 }}>
                <ErrorMessage
                    errors={errors}
                    name={name}
                    render={({ message }) => <div style={{ color: 'red' }}>{message}</div>}
                />
            </div>
        </div>
    );
};

export default RadioRhf;
